document.addEventListener('DOMContentLoaded', function() {
  let collectionDescription = document.querySelector(".hero__description");
  let colDesFulTrigger = document.querySelector(".hero__description .trigger-full--description"); 
  if(collectionDescription && colDesFulTrigger){
    colDesFulTrigger.addEventListener('click', ()=>{
      collectionDescription.classList.toggle("show-full-description");
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const url = window.location.href;

  if (url.indexOf("judgeme_review_source") !== -1) {
    let reviewsSection = document.querySelector("#judgeme_product_reviews");

    if (reviewsSection) {
      var offset = 200;
      var elementPosition = reviewsSection.getBoundingClientRect().top;

      if(window.innerWidth <= 768){
        offset = 100;
      }

      var offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      reviewsSection.addEventListener("scroll", function scrollHandler() {
        setTimeout(function () {
          reviewsSection.removeEventListener("scroll", scrollHandler);
        }, 200);
      });

      const button = reviewsSection.querySelector("[data-collapsible-trigger]");
      if (button) {
        setTimeout(function () {
          button.click();
        }, 400);
      }
    }
  }
});

document.addEventListener(
  "click",
  function (e) {
    var trigger = e.target.closest(
      ".jdgm-prev-badge, .jdgm-prev-badge__stars, .jdgm-preview-badge"
    );
    if (!trigger) return;

    var reviewsSection = document.querySelector("#judgeme_product_reviews");
    if (!reviewsSection) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    reviewsSection.scrollIntoView({ behavior: "smooth", block: "start" });
  },
  true
);